export const dateRequiredDirective = ($parse, defaultErrorMessageResolver) => {
  'ngInject';

  defaultErrorMessageResolver.getErrorMessages().then((errorMessages) => {
    errorMessages['dateRequired'] = 'Please select date';
  });
  return {
    require: 'ngModel',
    restrict: 'A',
    link: (scope, element, attrs, ngModel) => {
      ngModel.$validators.dateRequired = (value) => {
        //setTimeout(() => {
          let dateRequired = true;
          if(attrs.dateRequired) {
            dateRequired = $parse(attrs.dateRequired)(false);
          }
          if(dateRequired !== false){
            if(!value) {
              return false;
            }
            return true;
          } else{
            return true;
          }
      // }, 100);
      };
    }
  };
};



// WEBPACK FOOTER //
// ./src/app/common/components/datepicker/date-required.directive.js